import React, { useContext, useState } from "react";
import ModalWithCloseButton from "../../../components/modal/ModalWithCloseButton";
import { Box, Button, Divider, Typography } from "@mui/material";

import { useNavigate } from "react-router-dom";
import account from "../../../data/accounts.json";
import RegisterContext from "../../../context/RegisterContext";
import { useRegisterCustomer } from "../../../hooks/api/post";
import { toast } from "react-toastify";
import CircleLoad from "../../../components/Spinner/CircleLoad";
import { FormWrapper } from "../../../components/FormWrapper/FormWrapper";
import Swal from "sweetalert2";
function Payment({
  open = false,
  handleClose,
}: {
  open: boolean;
  handleClose?: any;
}) {
  // let productType;
  const { state } = useContext(RegisterContext) as IRegisterContextProps;
  const [loadingState, setLoadingState] = useState(false);

  let product = Number(state?.values?.productType) - 1;
  const navigate = useNavigate();
  const registerAPI = useRegisterCustomer();

  function handleConfirmPayment() {
    setLoadingState(true);
    registerAPI.mutate(
      {
        ...state.values,
        paymentSource: 5,
      },
      {
        onSuccess: (response) => {
          // navigate("successful-registration");
          navigate("/register/onboarding-feedback");
        },
        onError: (err: any) => {
          if (err.response.status === 400) {
            Swal.fire({
              title:
                err.response?.data?.errorMessages?.[0]?.type ||
                "Account already exists",
              text:
                err.response?.data?.errorMessages?.[0]?.message ||
                "Sorry! You already onboarded for this product already",
              icon: "error",
              confirmButtonText: "Continue",
            });
          } else {
            toast.dismiss();
            toast.error(err.message);
          }
        },
        onSettled: () => {
          setLoadingState(false);
        },
      }
    );
  }
  return (
    <ModalWithCloseButton open={open} handleClose={handleClose}>
      <Box p={2}>
        <Typography
          variant="h5"
          align="center"
          fontWeight={700}
          color="primary"
        >
          {" "}
          Fund Your Account{" "}
        </Typography>
        <Box mt={0.5} mb={1.5}>
          <Divider />
        </Box>
        <Typography variant="body2">
          This works like transfering to a regular bank account, Transfer from
          any source to the account numbers below, Funds will be credited to
          your investment account
        </Typography>
        <Box mt={2}>
          <FormWrapper title="Local Transfer">
            <Box>
              <Typography
                mb={2}
                fontWeight={600}
                fontSize={"medium"}
                variant="body2"
              >
                Amount: {state?.values?.productType !== "4" ? "NGN " : "USD "}
                {state?.values?.amount}
              </Typography>
              <Typography variant="body1" fontWeight={800} fontSize={"medium"}>
                Account Name: {account?.bank_details?.[product]?.account_name}
              </Typography>
              <Typography variant="body2" fontSize="small" mt={0.5}>
                Bank Name: {account?.bank_details?.[product]?.bank_name}
              </Typography>
              <Typography fontWeight={800} fontSize={"medium"} variant="body2">
                {account?.bank_details?.[product]?.account_number}
              </Typography>

              <Box>
                {/* <Typography variant="body2" fontSize="small" mt={1.5}>
                  Kindly click on confirm payment after initiating the transfer.
                  This process can take up to 30 minutes. Once complete, we will
                  send your payment confirmation and your online login
                  credential to your registered email.
                </Typography> */}
              </Box>
            </Box>
          </FormWrapper>
          <Box sx={{ display: "flex", justifyContent: "right" }}>
            <Button variant="contained" onClick={handleConfirmPayment}>
              Confirm Payment
            </Button>
          </Box>
        </Box>
      </Box>
      <CircleLoad loading={loadingState} color="#d6c0e7" />
    </ModalWithCloseButton>
  );
}

export default Payment;
